import { createSlice } from "@reduxjs/toolkit";
import { IDescriptionSlice } from "../../../models/master/descriptions";

const initialDescriptionState: IDescriptionSlice = {
    descriptions: undefined,
    description: undefined
};

const descriptionSlice = createSlice({
    name: "description",
    initialState: initialDescriptionState,
    reducers: {
        setDescriptions: (state, action: { payload: any }) => {
            state.descriptions = action.payload;
        },
        setDescription: (state, action: { payload: any }) => {
            state.description = action.payload;
        },

    },
});

export const { setDescriptions, setDescription } =
    descriptionSlice.actions;

const descriptionReducer = descriptionSlice.reducer;

export type descriptionState = ReturnType<typeof descriptionReducer>;

export default descriptionReducer;